export enum CardActionLogTypes {
  Info = 'Info',
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning',
}
